import React from 'react';
import { formatNPR } from '../../utils/currency';
import { formatBuyerOrderStatus } from '../../utils/orderStatus';

const Table = ({ title, data, loading, error, onSort, sortColumn }) => {
	const handlePay = (item) => {
		console.log(item);
	};

	const getSortIndicator = (column) => {
		if (sortColumn === column) {
			return '▲';
		} else if (sortColumn === `-${column}`) {
			return '▼';
		}
		return '';
	};

	return (
		<div className="max-w-screen-2xl mx-auto ">
			<div className="rounded-md ">
				<div className="flex flex-col">
					{title && <h3 className="text-lg font-medium mb-5">{title}</h3>}
					<div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div className="align-middle inline-block rounded-md min-w-full pb-2 sm:px-6 lg:px-8">
							<div className="overflow-hidden border-b last:border-b-0 border-gray-100 rounded-md">
								<table className="table-auto min-w-full border border-gray-100 divide-y divide-gray-200">
									<thead className="bg-gray-50">
										<tr className="text-xs bg-gray-100">
											<th
												scope="col"
												className="font-semibold px-6 py-2 text-gray-700 uppercase tracking-wider text-left cursor-pointer"
												onClick={() => onSort('created_at')}
											>
												Date {getSortIndicator('created_at')}
											</th>
											<th
												scope="col"
												className="font-semibold px-6 py-2 text-gray-700 uppercase tracking-wider text-left cursor-pointer"
												onClick={() => onSort('order_number')}
											>
												Order ID {getSortIndicator('order_number')}
											</th>
											<th
												scope="col"
												className="font-semibold px-6 py-2 text-gray-700 uppercase tracking-wider text-left cursor-pointer"
												onClick={() => onSort('bill_amount')}
											>
												Order Total {getSortIndicator('bill_amount')}
											</th>
											<th
												scope="col"
												className="font-semibold px-6 py-2 text-gray-700 uppercase tracking-wider text-right cursor-pointer"
												onClick={() => onSort('status')}
											>
												Status {getSortIndicator('status')}
											</th>
										</tr>
									</thead>
									<tbody className="bg-white divide-y divide-gray-200">
										{loading ? (
											[...Array(5)].map((_, index) => (
												<tr key={index} className="hover:bg-gray-100 animate-pulse">
													<td className="px-6 py-1 whitespace-nowrap">
														<div className="h-4 bg-gray-200 rounded w-32"></div>
													</td>
													<td className="px-6 py-1 whitespace-nowrap">
														<div className="h-4 bg-gray-200 rounded w-48"></div>
													</td>
													<td className="px-6 py-1 whitespace-nowrap">
														<div className="h-4 bg-gray-200 rounded w-24"></div>
													</td>
													<td className="px-6 py-1 whitespace-nowrap text-right">
														<div className="h-8 bg-gray-200 rounded-md w-16 float-right"></div>
													</td>
												</tr>
											))
										) : error ? (
											<tr>
												<td colSpan="4" className="text-center py-4">
													<p className="text-red-500 text-xl">Error</p>
												</td>
											</tr>
										) : (
											data &&
											data?.results?.map((item, index) => (
												<tr
													key={index}
													className="hover:bg-gray-100 cursor-pointer"
													onClick={() => (window.location.href = `/order/${item.order_number}`)}
												>
													<td className="px-6 py-1 whitespace-nowrap font-bold text-left font-DejaVu">
														{new Date(item.created_at).toISOString().split("T")[0].replace(/-/g, "/")}
													</td>
													<td className="px-6 py-1 whitespace-nowrap font-normal text-gray-500">
														{item.order_number}
													</td>
													<td className="px-6 py-1 whitespace-nowrap font-bold text-left">
														{formatNPR(item.bill_amount)}
													</td>
													<td className="px-6 py-1 whitespace-nowrap text-right font-bold font-DejaVu k-grid">
														{!item?.is_paid ? (
															<button
																onClick={(e) => {
																	e.stopPropagation();
																	handlePay();
																}}
																className="text-brand-600 m-1 rounded-md border-2 px-2"
															>
																Pay
															</button>
														) : (
															<p
																className={`m-1 rounded-md capitalize ${item.status === "draft"
																	? "text-gray-500"
																	: item.status === "Processing"
																		? "text-sky-600"
																		: item.status === "Shipped"
																			? "text-amber-600"
																			: item.status === "Delivered"
																				? "text-brand-600"
																				: "text-black"
																	}`}
															>
																{formatBuyerOrderStatus(item.status)}
															</p>
														)}
													</td>
												</tr>
											))
										)}
										{error && (
											<p className="text-red-500 text-xl text-center">
												{error}
											</p>
										)}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Table;